<mat-progress-spinner [class]="classes"
                      [color]="color"
                      [mode]="mode"
                      *ngIf="condition"
                      [strokeWidth]="strokeWidth"
                      [diameter]="diameter"
                      [value]="value">
</mat-progress-spinner>
<span *ngIf="txt" class="progress-spinner__txt">{{ txt | translate }}</span>
